import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Collapse,
    Tooltip,
    Box,
    Button,
    Typography,
    Checkbox,
    TextField,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Menu,
    TablePagination
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { ImagePaths } from "../../../../../Utility/ImagePaths";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import RestAPIService from "../../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../../Utility/API/Serviceurls";
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import Loader from "../../../../../Components/Loader";
import { formatDate, CheckAccessFunc, AmountFormat } from "../../../../../Components/CommonFunctions/CommonFunctions";
import { CommonPatientDetails, ReasonPopup } from "../../../../../Components/Common Components/CommonComponents";
import CommonDatePicker from "../../../../../Components/Common Components/CommonDatePicker";
import { DateTime } from "luxon";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { localGetItem, setCachevalue } from "../../../../../Utility/Services/CacheProviderService";
import { Colors } from "../../../../../Styles/Colors";

const AcceptedOrder = (props) => {
    const history = useHistory();
    const location = useLocation();
    const [ordersList, setOrdersList] = useState([]);
    const [SelectedOrderId, setSelectedOrderId] = useState(null);
    const [SelectedPatientId, setSelectedPatientId] = useState(null);
    const [cancelService, setCancelService] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedRow, setselectedRow] = useState(null);
    const [anchorEl, setanchorEl] = useState(null);
    const [isloader, setisloader] = useState(false);
    let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const [loginInfo, setLoginInfo] = useState(loggedInUserInfo)
    const [expandedRows, setExpandedRows] = useState({});
    const [filters, setFilters] = useState({ patientName: '', patientType: '', fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'), toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'), dateIndex: 1 });
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const [orderCount, setorderCount] = useState({});
    const userAccess = loginInfo.module_name === "Radiology" ? CheckAccessFunc("Radiology", "Home", 'Order', null, "Tab") : CheckAccessFunc("Laboratory", "Home", 'Order', null, "Tab")
    useEffect(() => {
        getPendingOrdersList()
    }, [filters?.patientType, filters?.fromDate, filters?.toDate, filters?.dateIndex])


    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const LoaderFunction = (key) => {
        setisloader(key);
    };

    // Pagination Handlers
    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredOrders = ordersList?.filter((data) =>
    (data?.patient_name?.toLowerCase()?.includes(filters?.patientName?.toLowerCase()) ||
        data?.order_number?.toLowerCase()?.includes(filters?.patientName?.toLowerCase()))
    );

    const paginatedOrders = filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const getPendingOrdersList = () => {
        try {
            setisloader(true)
            let ApiUrl = loginInfo.module_name === "Radiology" ? Serviceurls.PENDING_ORDER_LIST_RAD : (localGetItem('is_investigation_module') === "true") ? Serviceurls.PENDING_ORDER_LIST_INVESTIGATION : Serviceurls.PENDING_ORDER_LIST_LAB;
            RestAPIService.getAll(ApiUrl + `?patient_type=${filters?.patientType ? filters?.patientType : "op,ip,self"}&from_date=${filters?.fromDate}&to_date=${filters?.toDate}&status=Accepted&clinic_id=${loginInfo.clinic_id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setOrdersList(response.data.data || [])
                        setorderCount(response?.data?.counts || {})
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const popupClose = () => {
        setCancelService(null);
        setselectedRow(null)
    }

    const clearFunction = () => {
        setCancelService(null);
    }

    const cancelServices = (remarks) => {
        try {
            postPendingOrder(cancelService?.order_id ? cancelService?.order_line_items?.map((list) => list?.id) : [cancelService?.id], "Cancelled", remarks, cancelService?.is_ip)
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    const postPendingOrder = (Ids = [], status, remarks = "", is_ip = false) => {
        try {
            let data = {
                "line_item_ids": Ids,
                "post_type": status,
                "remarks": remarks,
                "is_ip": is_ip,
            }
            let ApiUrl = loginInfo.module_name === "Radiology" ? Serviceurls.PENDING_ORDER_LIST_RAD : (localGetItem('is_investigation_module') === "true") ? Serviceurls.PENDING_ORDER_LIST_INVESTIGATION : Serviceurls.PENDING_ORDER_LIST_LAB;
            RestAPIService.create(data, ApiUrl)
                .then((response) => {
                    if (response.data.status === 'success') {
                        LoaderFunction(false);
                        successMessage(response.data.message);
                        getPendingOrdersList()
                        clearFunction()
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    const handleCheckChange = (ID, serviceId = null, PatientId = null) => {
        if (serviceId && (PatientId === SelectedPatientId || SelectedPatientId === null)) {
            let Order = ordersList?.map((row) =>
                (row.order_id === ID) ? {
                    ...row,
                    order_line_items: row.order_line_items.map((service) =>
                        service.id === serviceId ? {
                            ...service,
                            order_selected: !service.order_selected,
                        } : service
                    ),
                } : row
            )
            setOrdersList(Order)
            setSelectedOrderId(ID)
            setSelectedPatientId(PatientId)
            const isAnyOrderisSeleceted = Order.some(order => order?.order_selected || order?.order_line_items.some(service => service?.order_selected))
            if (!isAnyOrderisSeleceted) {
                setSelectedOrderId(null)
                setSelectedPatientId(null)

            }
        } else {
            if ((PatientId === SelectedPatientId || SelectedPatientId === null)) {
                let Order = ordersList?.map((row) =>
                    row.order_id === ID ? {
                        ...row,
                        order_selected: !row.order_selected,
                        order_line_items: row.order_line_items.map((service) => ({
                            ...service,
                            order_selected: !row.order_selected,
                        })
                        ),
                    } : row
                )
                setOrdersList(Order)
                setSelectedPatientId(PatientId)
                const isAnyOrderisSeleceted = Order.some(order => order?.order_selected || order?.order_line_items.some(service => service?.order_selected))
                if (!isAnyOrderisSeleceted) {
                    setSelectedPatientId(null)
                }
            }
        }
    };

    const FilterDate = (from, to, index) => {
        setFilters((prev) => ({
            ...prev,
            fromDate: from,
            toDate: to,
            dateIndex: index
        }))
    }

    const toggleRow = (orderId) => {
        setExpandedRows((prev) => ({
            ...prev,
            [orderId]: !prev[orderId]
        }));
    };

    const getResultStatus = (row) => {
        return row?.order_line_items?.every(item => {
            const result_status = item?.result_status || item?.result_status?.result_status;
            return (result_status !== "Result Completed" && result_status !== "Result Delivered")
        })
    }

    const renderCard = (img, label, count = 0) => {
        const countStr = String(count);

        // Dynamic font size: shrink when digits exceed 10
        const fontSize = countStr.length > 13 ? '0.7rem' : '0.9rem';

        return (
            <Paper component={'div'} sx={{ width: "10vw", display: 'flex', alignItems: 'center' }}>
                <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'}>
                    <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box component={'img'} src={img} marginLeft={'.2vw'} height={'5dvh'} width={'2.3dvw'} />
                    </Box>

                    <Box component={'div'}>
                        <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{label}</Typography>

                        {/* Wrap count with tooltip */}
                        <Tooltip title={countStr.length > 13 ? countStr : ""}>
                            <Typography
                                fontSize={fontSize}
                                fontWeight={600}
                                sx={{ cursor: countStr.length > 13 ? "pointer" : "default" }}
                            >
                                {count}
                            </Typography>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>
        );
    };

    return (
        <Box>
            <Box flex={1} sx={{ display: 'flex', marginRight: ".5vw", mt: loginInfo?.module_name === 'Radiology' ? "1vw" : "0vw" }}>
                <Box flex={0.5} display={'flex'} justifyContent={'space-between'} >
                    {renderCard(ImagePaths.TotalOrders.default, 'Total Orders', orderCount?.total_count || 0)}
                    {renderCard(ImagePaths.TotalOP.default, 'Total OP Orders', orderCount?.op || 0)}
                    {renderCard(ImagePaths.TotalIP.default, 'Total IP Orders', orderCount?.ip || 0)}
                    {renderCard(ImagePaths.TotalSelf.default, 'Total Self Orders', orderCount?.lab_self || 0)}
                </Box>
                <Box flex={0.5} sx={{ display: 'flex', justifyContent: "flex-end", marginRight: "1vw"}}>
                    <TextField
                        size='small'
                        fullWidth
                        sx={{ width: "15dvw", mr: "1vw" }}
                        value={filters?.patientName || ""}
                        onChange={(e) => {
                            setFilters((prev) => ({ ...prev, patientName: e.target.value }))
                        }}
                        label={"Search Patient Name / Order No"}
                        autoComplete='off'
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && e.target.value !== '' && e.target.value?.length > 4) {
                            }
                        }}
                    />
                    <FormControl sx={{ width: '15dvw', mr: "1vw" }} size='small'>
                        <InputLabel>Patient Type</InputLabel>
                        <Select
                            label='Patient Type'
                            value={filters.patientType}
                            onChange={(e) => {
                                setFilters((prev) => ({ ...prev, patientType: e.target.value }))
                            }}
                        >
                            <MenuItem value={''}>All</MenuItem>
                            <MenuItem value={'op'}>OP</MenuItem>
                            <MenuItem value={'ip'}>IP</MenuItem>
                            <MenuItem value={'self'}>Self</MenuItem>
                        </Select>
                    </FormControl>
                    <Box className='eMed_IP_AptDateFlt'>
                        <CommonDatePicker
                            FromDate={filters?.fromDate}
                            ToDate={filters?.toDate}
                            DateIndex={filters?.dateIndex}
                            SelectedDates={FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                </Box>
            </Box>
            <TableContainer component={Paper} style={{ padding: "10px", height: "58.5dvh" }}>
                <Table size='small'>
                    <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                        <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Patient Details</TableCell>
                            {loginInfo.module_name === "Laboratory" ?  <TableCell>Doctor Name</TableCell> : null }
                            <TableCell>Order Details</TableCell>
                            <TableCell>OP / IP Number</TableCell>
                            <TableCell>No of Services</TableCell>
                            <TableCell>Created By</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedOrders?.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    <Typography sx={{ marginTop: "5vh" }}>No Records Found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            paginatedOrders.map((row, index) => {
                                const roomName = `${row?.bed_number || ''}/${row?.room_number || ''}/${row?.ward_name || ''}/${row?.block_name|| ''}`
                                return (
                                <React.Fragment key={row.id}>
                                    {/* Parent Row */}
                                    <TableRow>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <Box>
                                                <CommonPatientDetails disablePhoto={true} data={row} />
                                            </Box>
                                        </TableCell>
                                        {loginInfo.module_name === "Laboratory" ?  <TableCell>
                                            <Box>
                                                {row?.doctor_name ? row?.doctor_name?.length > 20 ?
                                                    <Tooltip placement="top" title={row?.doctor_name}>
                                                        <Typography fontSize={'0.9vw'}>{row?.doctor_name?.slice(0, 20) + '...'}</Typography>
                                                    </Tooltip> :
                                                    <Typography fontSize={'0.9vw'}>{row?.doctor_name || "-"}</Typography> : '-'}
                                                {
                                                    row?.is_ip ?
                                                        roomName?.length > 20 ?
                                                            <Tooltip placement="top" title={roomName}>
                                                                <Typography fontSize={'0.9vw'}>{roomName?.slice(0, 20) + '...'}</Typography>
                                                            </Tooltip> :
                                                            <Typography fontSize={'0.9vw'}>{roomName}</Typography> || '-' : null
                                                }
                                            </Box>
                                        </TableCell> : null }
                                        <TableCell>{row.order_number ? row.order_number : "-"}</TableCell>
                                        <TableCell>{row.module_number ? row.module_number : "-"}</TableCell>
                                        <TableCell>{row?.pending_line_count ? row?.pending_line_count : "-"}</TableCell>
                                        <TableCell>{row.created_by ? row.created_by : "-"}</TableCell>
                                        <TableCell>
                                            <Tooltip title={"More"} placement='top' arrow>
                                                {userAccess?.editAccess && <IconButton
                                                    emed_tid="drg_more_icon"
                                                    onClick={(e) => {
                                                        setanchorEl(e.currentTarget)
                                                        setselectedRow(row)
                                                    }}
                                                >
                                                    <MoreVertIcon />
                                                </IconButton>}
                                            </Tooltip>
                                            {/* <IconButton onClick={() => {
                                                let Order = ordersList?.map((order, orderIndex) =>
                                                    orderIndex === index ? {
                                                        ...order,
                                                        order_open: order.order_open ? false : true,
                                                    } : order
                                                )
                                                setOrdersList(Order)
                                            }}>
                                                {row.order_open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton> */}
                                            <IconButton onClick={() => toggleRow(row.order_id)}>
                                                {expandedRows[row.order_id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                            {(selectedRow?.order_id == row?.order_id && anchorEl) ?
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    open={Boolean(anchorEl)}
                                                    onClose={() => {
                                                        setanchorEl(null)
                                                        setselectedRow(null)

                                                    }}>
                                                    <MenuItem className="eMed_drugMenu"
                                                        disabled={props.fromRadiology ? !row?.is_ip : !(row?.is_ip && !row?.is_advance_adjusted && getResultStatus(row) && !row?.is_final_bill_generated)}
                                                        onClick={() => {
                                                            if (row?.is_ip) {
                                                                setanchorEl(null)
                                                                setselectedRow(null)
                                                                setCancelService(row)
                                                            }
                                                        }}
                                                    >{"Cancel"}</MenuItem>
                                                </Menu> : null}
                                        </TableCell>
                                    </TableRow>
                                    {/* Expandable Child Row */}
                                    < TableRow >
                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                                            <Collapse in={!!expandedRows[row.order_id]} timeout="auto" unmountOnExit>
                                                <Table size="small" style={{ marginBottom: "10px" }}>
                                                    <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                                                        <TableRow>
                                                            <TableCell>S No</TableCell>
                                                            <TableCell>Service Name</TableCell>
                                                            <TableCell>Service Head</TableCell>
                                                            <TableCell>Doctor Name</TableCell>
                                                            {userAccess?.editAccess && <TableCell>Action</TableCell>}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {row?.order_line_items && row?.order_line_items.map((item, i) => {
                                                            const result_status = item?.result_status || item?.result_status?.result_status;
                                                            const enableCancel = (row?.is_ip && !item.is_advance_adjusted && (result_status !== "Result Completed" && result_status !== "Result Delivered") && !row?.is_final_bill_generated);
                                                            return(
                                                            <TableRow key={i}>
                                                                <TableCell>{i + 1}</TableCell>
                                                                <TableCell>{item.service_name ? item.service_name : "-"}</TableCell>
                                                                <TableCell>{item.service_head_name ? item.service_head_name : "-"}</TableCell>
                                                                <TableCell>{item.bill_doctor_name ? item.bill_doctor_name : "-"}</TableCell>
                                                                {userAccess?.editAccess && <TableCell>
                                                                    <Tooltip title={"Cancel"} placement="top" arrow>
                                                                        <IconButton emed_tid={'cancel'} className='eMed_usrconf_btn'
                                                                            disabled={props.fromRadiology ? true : !enableCancel}
                                                                            onClick={() => {
                                                                                if (row?.is_ip) {
                                                                                    setCancelService({ ...item, "is_ip": row?.is_ip })
                                                                                }
                                                                            }}>
                                                                            <img src={(props.fromRadiology ? false : enableCancel) ? ImagePaths.CancelOrderOn.default : ImagePaths.CancellOrderOff.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </TableCell>}
                                                            </TableRow>
                                                        )})}
                                                    </TableBody>
                                                </Table>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                                )
                            }))}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* Pagination Component */}
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredOrders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            {
                message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {
                message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {isloader ? <Loader loaderOpen={isloader} /> : null}
            {cancelService ? <ReasonPopup
                title={"Cancellation Remarks"}
                AlertPopupClose={popupClose.bind(this)}
                label={'Enter cancel remarks here'}
                btntext={'close'}
                btnvarient={'outlined'}
                btntext1={'Cancel'}
                btnvarient1={'contained'}
                btncolor={'error'}
                sendCmt={cancelServices.bind(this)}
                ErrorNotes={cancelService?.advance_adjusted_amount ? `The adjusted advance amount of ${AmountFormat(cancelService?.advance_adjusted_amount)} will be added back to the advance.` : null}
            /> : null}
        </Box >

    );
};

export default AcceptedOrder;

